module.exports = __webpack_public_path__ + "static/the-circle-a2734c3b646dd8e5d5f5df7884b2209b.jpg";